
(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  const section = document.querySelector('[data-ae-main-cart]');
  if (!section) return;
  if (section.dataset.aeBound === 'true') return;
  section.dataset.aeBound = 'true';

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
    }
    return '£' + (Number(cents || 0) / 100).toFixed(2);
  };

  let pending = false;

  const showError = (message) => {
    let toast = section.querySelector('[data-ae-cart-error]');
    if (!toast) {
      toast = document.createElement('p');
      toast.className = 'ae-main-cart__error';
      toast.setAttribute('data-ae-cart-error', '');
      toast.setAttribute('role', 'alert');
      const layout = section.querySelector('.ae-main-cart__layout') || section;
      layout.parentNode.insertBefore(toast, layout);
    }
    toast.textContent = message;
    setTimeout(() => { if (toast.textContent === message) toast.textContent = ''; }, 6000);
  };

  const changeQty = async (key, qty) => {
    if (pending) return;
    pending = true;
    section.classList.add('is-updating');
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, parseInt(qty, 10) || 0) })
      });

      if (!r.ok) {
        let msg = 'Could not update item. Please try again.';
        try {
          const errBody = await r.json();
          if (errBody && errBody.description) msg = errBody.description;
        } catch (_) { /* swallow parse errors on error body */ }
        showError(msg);
        return;
      }

      const cart = await r.json();
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      } else {
        document.dispatchEvent(new Event('cart-updated'));
      }

      const stillThere = (cart.items || []).some((i) => i.key === key);
      if (!stillThere || qty === 0) {
        window.location.reload();
        return;
      }

      const row = section.querySelector('[data-key="' + CSS.escape(key) + '"]');
      if (row) {
        const item = cart.items.find((i) => i.key === key);
        if (item) {
          const priceEl = row.querySelector('.ae-main-cart__item-price');
          if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
          const qtyEl = row.querySelector('[data-ae-cart-qty]');
          if (qtyEl) qtyEl.value = item.quantity;
        }
      }

      const subtotalEl = section.querySelector('[data-ae-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      const countEl = section.querySelector('.ae-main-cart__count');
      if (countEl) {
        const itemWord = cart.item_count === 1 ? 'item' : 'items';
        countEl.textContent = cart.item_count + ' ' + itemWord;
      }
    } catch (err) {
      console.error('Cart update failed', err);
    } finally {
      pending = false;
      section.classList.remove('is-updating');
    }
  };

  section.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-ae-cart-minus]');
    const plus = event.target.closest('[data-ae-cart-plus]');
    const remove = event.target.closest('[data-ae-cart-remove]');
    if (!minus && !plus && !remove) return;
    event.preventDefault();
    const row = event.target.closest('[data-ae-cart-item]');
    if (!row) return;
    const key = row.dataset.key;
    const qtyEl = row.querySelector('[data-ae-cart-qty]');
    const cur = qtyEl ? parseInt(qtyEl.value, 10) || 0 : 0;
    if (remove) {
      changeQty(key, 0);
    } else if (minus) {
      changeQty(key, Math.max(0, cur - 1));
    } else if (plus) {
      changeQty(key, cur + 1);
    }
  });

  let inputTimer = null;
  section.addEventListener('change', (event) => {
    const input = event.target.closest('[data-ae-cart-qty]');
    if (!input) return;
    const row = input.closest('[data-ae-cart-item]');
    if (!row) return;
    const key = row.dataset.key;
    const newQty = parseInt(input.value, 10) || 0;
    if (inputTimer) clearTimeout(inputTimer);
    inputTimer = setTimeout(() => changeQty(key, newQty), 250);
  });
});
